import { createFileRoute } from '@tanstack/react-router';
import { ChoicesOverview } from '../../features/choices/choicesOverview';
import {
  CHOICES_PERMISSIONS,
  createPermissionGuard,
  getPermissionSet,
} from '@bmwe/ui';

export const Route = createFileRoute('/auswahlfelder/')({
  component: ChoicesOverview,
  beforeLoad: createPermissionGuard(
    getPermissionSet(CHOICES_PERMISSIONS, 'READ'),
  ),
});

export const ChoicesOverviewRoute = Route;
